import type { TranslationCapabilities, TranslationLanguage } from './types';

export type MergedTranslationCapabilities = {
  languages: TranslationLanguage[];
  sourceLanguages: TranslationLanguage[];
  directionRules: string[];
  modelPriorities: string[][];
  streaming: boolean;
};

export function mergeTranslationCapabilities(items: TranslationCapabilities[]): MergedTranslationCapabilities | undefined {
  if (items.length === 0 || items.some((item) => item.model !== 'auto' || item.task !== 'translation' || item.languages.length === 0)) {
    return undefined;
  }
  const otherLanguageSets = items.slice(1).map((item) => new Set(item.languages.map((language) => language.code)));
  const languages = uniqueLanguages(items[0].languages).filter((language) => otherLanguageSets.every((set) => set.has(language.code)));
  if (languages.length === 0) return undefined;
  const sourceLanguages = items.every((item) => item.source_language_auto_detection)
    ? [{ code: 'auto', name: 'Auto Detect' }, ...languages]
    : languages;
  return {
    languages,
    sourceLanguages,
    directionRules: uniqueStrings(items.map((item) => item.direction_policy?.rule || '').filter(Boolean)),
    modelPriorities: items.map((item) => item.routing?.model_priority || []).filter((priority) => priority.length > 0),
    streaming: items.every((item) => item.streaming)
  };
}

function uniqueLanguages(items: TranslationLanguage[]) {
  const seen = new Set<string>();
  return items.filter((item) => {
    if (!item.code || seen.has(item.code)) return false;
    seen.add(item.code);
    return true;
  });
}

function uniqueStrings(items: string[]) {
  return Array.from(new Set(items));
}
